import database from "./db"
import indexedDB from "./indexedDB"
import global from "./global"

export async function insertArticeData(obj) {
    return new Promise((resolve,reject) => {
        if (global.isApp) {
            database.openDatabase().then(async flag => {
                if (flag) {
                    let createSql = 'create table if not exists artice_table("_id" INTEGER PRIMARY KEY AUTOINCREMENT, "typeName" varchar(10), "answer" text, "createTime" varchar(15))';
                    let inserRes = await database.executeSql(createSql);
                    console.log("创建问答表成功")
                    if (inserRes.status) {
                        try {
                            let time = Date.now()
                            let insertSql = "insert into artice_table (typeName, answer, createTime) values('";
                                insertSql += obj.typeName + "','";
                                insertSql += obj.answer + "','";
                                insertSql += time + "'";
                                insertSql += ')';
                            console.log(insertSql)
                            let insertRes = await database.executeSql(insertSql);
                            if (insertRes.status) {
                                resolve()
                                await database.closeDatabase();
                            }
                        } catch (e) {
                            reject()
                            console.log('插入失败，请检查', JSON.stringify(e))
                            await database.closeDatabase();
                        }
                    }
                }
            })
        } else {
            indexedDB.openIndexedDB().then( db => {
                // 建立读写事务,向对象仓库写入数据记录
                let request = db.transaction(['artice_table_v2'], 'readwrite').objectStore('artice_table_v2').add(obj)
                request.onsuccess = event => {
                    console.log('数据写入成功');
                    resolve()
                }
                request.onerror = event => {
                    console.log('数据写入失败');
                    reject()
                }
              }  
            )
        }
    })
}


export async function queryArticeList() {
    return new Promise((resolve,reject) => {
       if (global.isApp) {
        database.openDatabase().then(async flag => {
            if (flag) {
                try{
                    let querySql = "select * from artice_table";
                    let queryRes = await database.selectSql(querySql);
                    if (queryRes.status) {
                        resolve(queryRes)
                    } else {
                        reject()
                    }
                    await database.closeDatabase();
                }catch(e){
                    reject()
                    console.log('查询列表失败或表不存在，请检查', JSON.stringify(e))
                    await database.closeDatabase();
                }
            }
        })
       } else {
        indexedDB.openIndexedDB().then( db => {
            let list = []
            let store = db
            .transaction(['artice_table_v2'], 'readwrite') // 食物
            .objectStore('artice_table_v2') // 参考对象
            let request = store.openCursor() // 指针对象
            // 游标开启成功，逐行读数据
            request.onsuccess = function (event) {
            let cursor = event.target.result
            if (cursor) {
                // 必须要检查
                list.push(cursor.value)
                cursor.continue()
            } else {
                console.log('游标读取artice_table_v2的数据：', list)
                resolve({data: list})
            }
            }
            request.onerror = function (event) {
                console.log('获取列表失败')
                reject()
            }
          }  
        )
       }
    })
}


export async function insertChatData(obj) {
    return new Promise((resolve,reject) => {
        if (global.isApp) {
            database.openDatabase().then(async flag => {
                if (flag) {
                    let createSql = 'create table if not exists chat_table("_id" INTEGER PRIMARY KEY AUTOINCREMENT, "question" text, "answer" text)';
                    let inserRes = await database.executeSql(createSql);
                    console.log("创建聊天表成功")
                    if (inserRes.status) {
                        try {
                            let time = Date.now()
                            let insertSql = "insert into chat_table (question, answer) values('";
                                insertSql += obj.question + "','";
                                insertSql += obj.answer + "'";
                                insertSql += ')';
                            console.log(insertSql)
                            let insertRes = await database.executeSql(insertSql);
                            if (insertRes.status) {
                                resolve()
                                await database.closeDatabase();
                            }
                        } catch (e) {
                            reject()
                            console.log('插入失败，请检查', JSON.stringify(e))
                            await database.closeDatabase();
                        }
                    }
                }
            })
        } else {
            indexedDB.openIndexedDB().then( db => {
                // 建立读写事务,向对象仓库写入数据记录
                let request = db.transaction(['chat_table_v2'], 'readwrite').objectStore('chat_table_v2').add(obj)
                request.onsuccess = event => {
                    console.log('数据写入成功', event);
                    resolve(event)
                }
                request.onerror = event => {
                    console.log('数据写入失败');
                    reject()
                }
              }  
            )
        }
        
    })
}

export async function queryChatList() {
    return new Promise((resolve,reject) => {
        if (global.isApp) {
            database.openDatabase().then(async flag => {
                if (flag) {
                    try{
                        let querySql = "select * from chat_table";
                        let queryRes = await database.selectSql(querySql);
                        if (queryRes.status) {
                            resolve(queryRes)
                        } else {
                            reject()
                        }
                        await database.closeDatabase();
                    }catch(e){
                        reject()
                        console.log('查询列表失败或表不存在，请检查',  JSON.stringify(e))
                        await database.closeDatabase();
                    }
                }
            })
        } else {
            indexedDB.openIndexedDB().then( db => {
                let list = []
                let store = db
                .transaction(['chat_table_v2'], 'readwrite') // 食物
                .objectStore('chat_table_v2') // 参考对象
                let request = store.openCursor() // 指针对象
                // 游标开启成功，逐行读数据
                request.onsuccess = function (event) {
                    let cursor = event.target.result
                    if (cursor) {
                        // 必须要检查
                        list.push(cursor.value)
                        cursor.continue() // 遍历了存储对象中的所有内容
                    } else {
                        console.log('游标读取chat_table_v2的数据：', list)
                        resolve({data: list})
                    }
                }
                request.onerror = function (event) {
                    console.log('获取列表失败')
                    reject()
                }
              }  
            )
        }
    })
}

export async function insertSpecificData(obj) {
    return new Promise((resolve,reject) => {
        if (global.isApp) {
            database.openDatabase().then(async flag => {
                if (flag) {
                    let createSql = 'create table if not exists specific_table("_id" INTEGER PRIMARY KEY AUTOINCREMENT, "typeName" varchar(10), "question" text, "answer" text)';
                    let inserRes = await database.executeSql(createSql);
                    console.log("创建聊天表成功")
                    if (inserRes.status) {
                        try {
                            let time = Date.now()
                            let insertSql = "insert into specific_table (typeName, question, answer) values('";
                                insertSql += obj.typeName + "','";
                                insertSql += obj.question + "','";
                                insertSql += obj.answer + "'";
                                insertSql += ')';
                            console.log(insertSql)
                            let insertRes = await database.executeSql(insertSql);
                            if (insertRes.status) {
                                resolve()
                                await database.closeDatabase();
                            }
                        } catch (e) {
                            reject()
                            console.log('插入失败，请检查', JSON.stringify(e))
                            await database.closeDatabase();
                        }
                    }
                }
            })
        } else {
            indexedDB.openIndexedDB().then( db => {
                // 建立读写事务,向对象仓库写入数据记录
                let request = db.transaction(['specific_table_v2'], 'readwrite').objectStore('specific_table_v2').add(obj)
                request.onsuccess = event => {
                    console.log('数据写入成功');
                    resolve()
                }
                request.onerror = event => {
                    console.log('数据写入失败');
                    reject()
                }
              }  
            )
        }
    })
}

export async function querySpecificList(typeName) {
    return new Promise((resolve,reject) => {
        if (global.isApp) {
            database.openDatabase().then(async flag => {
                if (flag) {
                    try{
                        let querySql = "select * from specific_table where typeName = '" + typeName + "'";
                        console.log(querySql)
                        let queryRes = await database.selectSql(querySql);
                        console.log(queryRes)
                        if (queryRes.status) {
                            resolve(queryRes)
                        } else {
                            reject()
                        }
                        await database.closeDatabase();
                    }catch(e){
                        reject()
                        console.log('查询列表失败或表不存在，请检查', JSON.stringify(e))
                        await database.closeDatabase();
                    }
                }
            })
        } else {
            indexedDB.openIndexedDB().then( db => {
                let list = []
                let store = db
                .transaction(['specific_table_v2'], 'readwrite') // 食物
                .objectStore('specific_table_v2') // 参考对象
                // 单索引
                let result = store.index('typeName');
                // 打开游标
                let request = result.openCursor(IDBKeyRange.only(typeName));	//条件查询
                // 游标开启成功，逐行读数据
                request.onsuccess = function (event) {
                let cursor = event.target.result
                if (cursor) {
                    // 必须要检查
                    list.push(cursor.value)
                    cursor.continue()
                } else {
                    console.log('游标读取的数据：', list)
                    resolve({data: list})
                }
                }
                request.onerror = function (event) {
                    console.log('获取列表失败')
                    reject()
                }
              }  
            )
        }
    })
}





// WEBPACK FOOTER //
// ./src/assets/js/select.js